import { useEffect, useState } from 'react';
import { getAllowedCommands } from '../Knowledge/KnowledgeUtils';
import { isMockMode } from './mockAdminData';
import { useAuth } from '../auth';

/**
 * Admin-only gate. Unlike useAdminPermissions (Manager + Admin), this checks
 * for attendance commands that are wired only on the Admin role.
 *
 * Keyed on the signed-in operator's name because the Header mounts this on
 * /login as well, where there is nobody to authorize: the ACC was being asked
 * `get_allowed_commands` with `user_name: null` and answering 401 on every
 * visit to the login page. Waiting for the name also means the answer is
 * re-fetched for whoever signs in, rather than staying on the first miss.
 */
export const useAdminOnlyPermissions = () => {
    const { user } = useAuth();
    const userName = user?.name || null;
    const [isAdmin, setIsAdmin] = useState(isMockMode());
    const [loading, setLoading] = useState(!isMockMode());

    useEffect(() => {
        if (isMockMode()) {
            setIsAdmin(true);
            setLoading(false);
            return undefined;
        }
        if (!userName) {
            setIsAdmin(false);
            setLoading(false);
            return undefined;
        }
        let active = true;
        setLoading(true);
        (async () => {
            try {
                const commands = await getAllowedCommands();
                if (active) setIsAdmin(commands.includes('get_attendance_events'));
            } catch (e) {
                if (active) setIsAdmin(false);
            } finally {
                if (active) setLoading(false);
            }
        })();
        return () => {
            active = false;
        };
    }, [userName]);

    return { isAdmin, loading };
};
